export enum CarouselShortcutType {
    TO_NEXT_SLIDE = "TO_NEXT_SLIDE", // no meta
    TO_PREVIOUS_SLIDE = "TO_PREVIOUS_SLIDE", // no meta
    TO_FIRST_SLIDE = "TO_FIRST_SLIDE", // no meta
    TO_LAST_SLIDE = "TO_LAST_SLIDE",  // no meta
}